/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/031-mic': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.5 11A2.5 2.5 0 0010 8.5v-6a2.5 2.5 0 10-5 0v6A2.5 2.5 0 007.5 11zM11 7v1.5a3.5 3.5 0 11-7 0V7H3v1.5a4.5 4.5 0 004 4.472V15H5v1h5v-1H8v-2.028A4.5 4.5 0 0012 8.5V7h-1z"/>'
  }
})
